<template>
  <div :class="{'interactive-text': true, annotationOn: annotationOn}">
    <annotator :config="annotationConfig" :on="annotationOn">
      <slot></slot>
    </annotator>
  </div>
</template>

<script>

  import Annotator from '@/components/Annotator'

  export default {
    name: 'interactiveText',
    props: {
      annotationOn: {type: Boolean},
      annotationConfig: {type: Object}
    },
    components: { Annotator },
    data () {
      return {}
    }
  }

</script>

<style lang="scss">

  @import "~globals";

</style>



// WEBPACK FOOTER //
// src/components/_global/interactive-text.vue